/// <reference path="../include.ts" />

namespace project_guide {

	import View = alm.view.View;
	import TweenCSS = alm.util.TweenCSS;
	import Easing = alm.math.Easing;
	import Hash = alm.util.Hash;
	import WindowWatcher = alm.browser.WindowWatcher;
	import Region = project_common.Region;
	import Area = project_common.Area;
	import Zone = project_common.Zone;
	import Species = project_common.Species;
	import Lang = project_common.Lang;
	import Dom = alm.util.Dom;
	import DataParser = project_common.DataParser;
	import CommonLocalizable = project_common.CommonLocalizable;
	import Application = project_common.Application;
	import DomUtil = project_common.DomUtil;
	import GuideDetailBanner = project_common.GuideDetailBanner;

	export class CardView extends View<JQuery> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
			super(jQuery('#card-view'));
			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():JQuery {
			const view = this.getView();

			this.closeButton = view.find('.close-button');
			this.header = view.find('.zone-header-sticky');

			// reset
			this.clearContext();

			return view;
		}

		protected implReady(): void {
		}

		protected implFinalize(): void {
		}

		protected implShow(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Serial(
				new cmd.Func(():void => {
					this.closeButton.on('click', this.closeButtonClickHandler);

					// scroll
					{
						// list view to fixed
						const listView = ListView.getInstance();
						listView.saveScrollPosition();

						view.css({ display:'block', position: 'relative', top: 0 });

						// adjust size
						//this.resize();

						// card view to scrollable
						if (this.species) {
							this.scrollToSpecies(this.species, false);
						} else {
							this.scrollToTop(false);
						}
					}
				}),
				TweenCSS.fadeIn(view, useTransition ? 500 : 0, Easing.easeOutQuart, 'block', false),
			);
		}

		protected implHide(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Serial(
				new cmd.Func(():void => {

					// scroll
					{
						// card view to fixed
						view.css({ position: 'fixed', top: -WindowWatcher.getScrollTop() });
						Dom.scrollTo(0, false);

						// list view to scrollable
						const listView = ListView.getInstance();
						listView.loadScrollPosition();
					}

					this.closeButton.off('click', this.closeButtonClickHandler);
				}),
				TweenCSS.fadeOut(view, useTransition ? 500 : 0, Easing.easeOutQuart, true, false),
				new cmd.Func(():void => {
				}),
			);
		}





		public clearContext():void {
			const view = this.getView();

			view.find('.species-container').empty();
			view.find('.banner-container').empty();

			this.region = null;
			this.area = null;
			this.zone = null;
			this.species = null;

			this.speciesViewByUrn = {};

			this.images = [];
			//this.iconImages = [];
			//this.coverImages = [];
		}

		public setContext(region:Region, area:Area, zone:Zone, species:Species):void {
			this.clearContext();
			const lang = Application.getPresetContext().lang;
			const bannerData = Application.getBannerData().guide;

			this.region = region;
			this.area = area;
			this.zone = zone;
			this.species = species;

			const view = this.getView();
			view.addClass('urn-' + zone.urn);

			// header
			{
				const header = view.find('.zone-header-sticky');
				BindingUtil.setZoneHeaderText(header, region, area, zone, lang);
			}

			// species
			{
				const itemContainer = view.find('.species-container');
				const itemDataList = zone.species;
				const itemCount = itemDataList.length;
				for (let i = 0; i < itemCount; ++i) {
					const itemData = itemDataList[i];
					const itemView = this.createSpeciesView(zone, itemData, lang);
					itemContainer.append(itemView);
				}
			}

			// close button
			this.closeButton.text(DataParser.localize(CommonLocalizable.cardViewCloseButtonLabel, lang));

			// banner
			{
				const itemContainer = view.find('.banner-container');
				const itemDataList = bannerData.detail;
				const itemCount = itemDataList.length;
				for (let i = 0; i < itemCount; ++i) {
					const item = this.createBanner(itemDataList[i], lang);
					if (item) {
						itemContainer.append(item);
					}
				}
			}
		}

		private createSpeciesView(zone:Zone, species:Species, lang:Lang):JQuery {
			const view = jQuery(Dom.instantiate('card-item-species-template'));
			view.addClass('urn-' + species.urn);

			// register view
			this.speciesViewByUrn[species.urn] = view;

			// image
			{
				const imageContainer = view.find('.image-container');
				const image = imageContainer.find('.image');
				const defaultImageUrl = '../static/img/species-default-landscape-s.png';

				if (species.coverImageUrl) {
					//imageContainer.addClass('cover');
					//image.addClass('cover');
					DomUtil.loadImageToBackground(image, [species.coverImageUrl, species.iconImageUrl, defaultImageUrl]);
					//this.coverImages.push(image);
					this.images.push(image);
				} else {
					//imageContainer.addClass('icon');
					//image.addClass('icon');
					DomUtil.loadImageToBackground(image, [species.iconImageUrl, defaultImageUrl]);
					//this.iconImages.push(image);
					this.images.push(image);
				}
			}

			// name
			{
				const content = view.find('.name');
				BindingUtil.setSpeciesNameTexts(content, species, lang);
			}

			const commentary = DataParser.localize(species.commentary, lang);

			// description
			{
				const content = view.find('.detail');

				if (commentary) {
					const detail = commentary.details;
					if (detail) {
						content.css('display', 'block');

						const descriptionField = content.find('.text');
						DomUtil.setHtml(descriptionField, detail);

					} else {
						content.css('display', 'none');
					}
				} else {
					content.css('display', 'none');
				}
			}

			// commentary
			{
				const content = view.find('.commentary');

				if (commentary) {
					content.css('display', 'block');

					const titleField = content.find('.title');
					this.setText(titleField, commentary.title);

					const bodyField = content.find('.body');
					this.setText(bodyField, commentary.body);

					const authorField = content.find('.author');
					this.setText(authorField, commentary.author);

				} else {
					content.css('display', 'none');
				}
			}

			return view;
		}

		private setText(textField:JQuery, text:string, displayTarget:JQuery = null):void {
			if (displayTarget === null) {
				displayTarget = textField;
			}

			if (text) {
				displayTarget.css('display', 'block');
				DomUtil.setHtml(textField, text);
			} else {
				displayTarget.css('display', 'none');
				DomUtil.setHtml(textField, '');
			}
		}

		private createBanner(data:GuideDetailBanner, lang:Lang):JQuery {
			try {
				const view = jQuery(Dom.instantiate('large-banner-item-template'));

				// image
				view.find('.image img').attr('src', DataParser.localize(data.coverImageUrl, lang));

				// main
				const main = view.find('.main');
				DomUtil.setHtml(main.find('.title'), DataParser.localize(data.mainTitle, lang));
				DomUtil.setHtml(main.find('.body'), DataParser.localize(data.mainBody, lang));

				// detail
				const detail = view.find('.detail');
				DomUtil.setHtml(detail.find('.title'), DataParser.localize(data.detailTitle, lang));
				DomUtil.setHtml(detail.find('.body'), DataParser.localize(data.detailBody, lang));

				// link
				{
					const itemContainer = view.find('.link-container');
					const itemDataList = data.links;
					const itemCount = itemDataList.length;
					for (let i = 0; i < itemCount; ++i) {
						const item = BindingUtil.createBannerLink(itemDataList[i], lang);
						itemContainer.append(item);
					}
				}

				return view;

			} catch (error:any) {
				trace('[CardView] banner (card view) : invalid data, data =', data, ', error =', error);
				return null;
			}
		}





		public scrollToTop(useTransition:boolean = true):void {
			Dom.scrollTo(0, useTransition);
		}

		public scrollToSpecies(species:Species, useTransition:boolean = true):void {
			const view = this.speciesViewByUrn[species.urn];
			const headerHeight = this.header.outerHeight() || 70;
			const margin = 16;
			Dom.scrollTo(view.offset().top - (headerHeight + margin), useTransition);
		}





		/*
		public resize():void {
			this.resizeImages();
			//this.resizeIconImages();
			//this.resizeCoverImages();
		}

		private resizeImages():void {
			let imageWidth = -1;
			let imageHeight:number;
			const imageCount = this.images.length;
			for (let i = 0; i < imageCount; ++i) {
				const image = this.images[i];
				if (imageWidth < 0) {
					imageWidth = image.width();
					imageHeight = Math.round(imageWidth * (9 / 16));
				}
				image.css('height', imageHeight);
			}
		}

		/*
		private resizeIconImages():void {
			let imageWidth = -1;
			let imageHeight:number;
			const imageCount = this.iconImages.length;
			for (let i = 0; i < imageCount; ++i) {
				const image = this.iconImages[i];
				if (imageWidth < 0) {
					imageWidth = image.width();
					//imageHeight = imageWidth;
					imageHeight = Math.round(imageWidth * (9 / 16));
				}
				image.css('height', imageHeight);
			}
		}

		private resizeCoverImages():void {
			let imageWidth = -1;
			let imageHeight:number;
			const imageCount = this.coverImages.length;
			for (let i = 0; i < imageCount; ++i) {
				const image = this.coverImages[i];
				if (imageWidth < 0) {
					imageWidth = image.width();
					imageHeight = Math.round(imageWidth * (9 / 16));
				}
				image.css('height', imageHeight);
			}
		}
		*/





		private closeButtonClickHandler = (event:JQuery.ClickEvent):void => {
			this.dispatchEvent(new CardViewEvent(CardViewEvent.requireClose, this));
		};





		// --------------------------------------------------
		//
		// MEMBER
		//
		// --------------------------------------------------

		public static getInstance():CardView { return this.instance || (this.instance = new CardView()) };
		private static instance:CardView = null;

		private region:Region;
		private area:Area;
		private zone:Zone;
		private species:Species;

		private header:JQuery;
		private closeButton:JQuery;
		private speciesViewByUrn:Hash<JQuery>;

		private images:JQuery[];
		//private iconImages:JQuery[];
		//private coverImages:JQuery[];
	}
}
